<script setup lang="ts">
import { RedirectConfig } from '~/configs';

const scrollY = ref(0);
const isPageScrolled = computed(() => scrollY.value > 0);

const updateScrollY = () => {
  scrollY.value = window?.scrollY || 0;
};

onMounted(() => {
  window.addEventListener('scroll', updateScrollY);
});

onUnmounted(() => {
  window.removeEventListener('scroll', updateScrollY);
});

const { getTranslation } = useLanguage();
const { common } = getTranslation();
</script>

<template>
  <header :class="['fixed top-0 left-0 right-0 w-full z-[1000] py-8 xs:py-10 transition-all before:absolute before:inset-0 before:transition-all before:backdrop-blur', { 'before:bg-viola-400/60': isPageScrolled }]">
    <CommonContainer>
      <div class="flex items-start sm:items-center justify-between">
        <CommonLogo />
        <div class="flex flex-col items-end justify-center w-full">
          <NuxtLink
            :to="RedirectConfig.prescriberWebapp"
            target="_blank"
            class="block xs:hidden mr-10"
          >
            <BaseButton
              style-type="gray"
              size="sm"
              class="!py-2 !px-4 !line-clamp-1"
            >
              {{ common.buttons.header }}
            </BaseButton>
          </NuxtLink>
          <Menu />
        </div>
      </div>
    </CommonContainer>
  </header>
</template>
